/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-18 18:00:19
 * @modify date 2023-10-18 18:00:19
 * @desc Region 메인 화면 정의
 */


import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { requests } from "../../../common/RestAPI";
import { PLATFORM_URL } from "../../../value/Url";
import { POPUP_TYPE } from "../../../value/type";
import ContentsProps from "../../../interfaceTypes/ContentsProps";
import { PopupModalItemType } from "../../base/modal/PopupModal";
import { tableHeaders } from "./RegionData";
import RegionMgmt from "./RegionMgmt";
import { generateQueryParam, sleep } from "common/util";


export default function RegionMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [selectItems, setSelectItems] = useState([]);
    const [tableData, setTableData] = useState<any>([]);
    const [refreshYn, setRefreshYn] = useState(false);

    const [executeDeleteRegionYn, setExecuteDeleteRegionYn] = useState(false);
    const [actionResultTitle, setActionResultTitle] = useState("");
    const [actionResultMessage, setActionResultMessage] = useState("");
    const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
    const [actionResultCount, setActionResultCount] = useState(0);
    const headers = useMemo(() => tableHeaders, []);


    useEffect(() => {
        AlertFunction('');
    }, []);



    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    useEffect(() => {
        if(actionResults.length === 0) {
            return ;
        }
        if(actionResultMessage && actionResultTitle) {
            const items = actionResults.map((item, index) => {
                return { target: item.target, successYn: item.successYn, reason: item.reason}
            });
            const completeYn = items.length === selectItems.length ? true : false;
            props.showPopupModalCb({
                openYn: true,
                type: POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP,
                title: actionResultTitle,
                message: actionResultMessage,
                items: items,
                completeTargetText: t("REGION_NAME_TEXT"),
                code: "COMPLETE",
                cancelButtonYn: false,
                confirmButtonCb: confirmAction,
                completeYn: completeYn
            });

            if(completeYn) {
                props.setLoading(false);
            }
        }
        if(actionResults.length > 0) {
            setActionResultCount(actionResultCount - 1);
        }
    }, [actionResults, actionResultTitle, actionResultMessage]);


    useEffect(() => {
        if(actionResultCount === selectItems.length) {
            props.setLoading(true);
        }
        if(actionResultCount > 0) {
            if(executeDeleteRegionYn) {
                setActionResultTitle(t("REGION_DELETE_COMPLETE_TEXT"));
                setActionResultMessage(t("MESSAGE_REGION_DELETE_COMPLETE_MESSAGE"));
                executeDeleteRegion(selectItems[selectItems.length - actionResultCount]);
            }
        }
    }, [actionResultCount, executeDeleteRegionYn]);


    function executeResult(target, successYn, reason:string="") {
        const results = actionResults.concat([{target: target, successYn: successYn, reason:reason }]);
        setActionResults(results);
    }


    function executeDeleteRegion(item) {
        requests.delete(PLATFORM_URL.REGION + "/" + item.regionId)
        .then((response) => {
            executeResult(item.regionName, true);
        })
        .catch((error) => {
            executeResult(item.regionName, false);
        })
    }


    function confirmAction(code) {
        if(code === "REGION_DELETE") {
            setActionResultCount(selectItems.length);
            setExecuteDeleteRegionYn(true);
        } else if(code !== "COMPLETE") {
            setActionResultCount(selectItems.length);
        } else {
            setActionResultCount(0);
            setActionResults([]);
            setActionResultMessage("");
            setActionResultTitle("");
            setExecuteDeleteRegionYn(false);
            setRefreshYn(true);
            AlertFunction('');
        }
    }

    function clickActionMenu(code) {
        if(code === "REGION_SYNC") {
            requests.post(PLATFORM_URL.REGION + PLATFORM_URL.SYNC, {})
            .then(async (response) => {
                if (response.status === 200) {
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                    setRefreshYn(true);
                }
            })
        }
    }


    function executeLoadRegionList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }
        requests.get(PLATFORM_URL.REGION, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data?.items && pageIndex === response.data.page-1) {
                setTableData(response.data.items);
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }



    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeLoadRegionList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);

    return (
        <RegionMgmt
            clickActionMenu={clickActionMenu}
            fetchData={fetchData}
            currentPage={currentPage}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            infoText={infoText}
            infoError={infoError}
        />
    )
}